(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/OneDaciaHeaderDesktopMenuMegaDropdownColumns"] = factory();
	else
		root["@makolab/library-react/dist/OneDaciaHeaderDesktopMenuMegaDropdownColumns"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 279);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Link");

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/withWidth");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Columns", function() { return Columns; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_withWidth__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_withWidth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_withWidth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Link__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__columns_jss_js__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__links_links__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__links_links___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__links_links__);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Columns=function(_Component){_inherits(Columns,_Component);function Columns(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Columns);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Columns.__proto__||Object.getPrototypeOf(Columns)).call.apply(_ref,[this].concat(args))),_this),_this.alwaysVisibleList=function(){return['xs','sm'].includes(_this.props.width);},_this.renderActionLinks=function(column){var tmpLinks=column.actionLinks||[];if(!column.actionLinks||column.actionLinks&&!column.actionLinks.length){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__links_links___default.a,{links:tmpLinks});},_this.render=function(){var _this$props=_this.props,classes=_this$props.classes,column=_this$props.column,expandList=_this$props.expandList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.listItemWrapper)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Link___default.a,{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.title),href:column.url},column.title)),(expandList===column.title||!_this.alwaysVisibleList())&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,column.links.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.list)},column.links.map(function(link){if(!link.label){return null;}var target=link.openInNewTab?'_blank':null;var rel=link.openInNewTab?'noopener':null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:link['@id'],className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.listItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Link___default.a,{href:link.url,target:target,rel:rel,underline:'none',className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.listItemLink)},link.label));})),column.actionLinks&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.listItemActivelink)},_this.renderActionLinks(column))));},_temp),_possibleConstructorReturn(_this,_ret);}return Columns;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Columns.displayName='Columns';Columns.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,column:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,expandList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Columns.defaultProps={column:{}};/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_3_lodash_flow___default()([Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(__WEBPACK_IMPORTED_MODULE_7__columns_jss_js__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_5__material_ui_core_withWidth___default()()])(Columns));

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * [Material UI theme documentation]{@link https://material-ui.com/customization/themes/}
 * [Material UI default theme object]{@link https://material-ui.com/customization/default-theme/}
 * @param {Object} theme - Material UI theme object
 * @returns {Object} - custom jss styles object
 *//* harmony default export */ __webpack_exports__["a"] = (function(theme){var _listItemWrapper;return{// eslint-disable-line no-unused-vars
title:_defineProperty({// borderRight: '1px solid #f0f3f5',
color:'#000',display:'block',fontWeight:500,fontSize:'14px','&:hover':{textDecoration:'none'}},theme.breakpoints.up('md'),{borderRight:0}),list:_defineProperty({marginBottom:theme.spacing.unit*4+'px !important',paddingLeft:0,display:'block'},theme.breakpoints.up('md'),{display:'block',marginBottom:theme.spacing.unit*2.5+'px !important!','&:not(:first-child)':{marginBottom:theme.spacing.unit*4+'px !important'}}),listItem:_defineProperty({fontSize:'14px',lineHeight:'20px','&:not(:last-child)':{marginBottom:theme.spacing.unit*2}},theme.breakpoints.up('md'),{'&:not(:last-child)':{marginBottom:theme.spacing.unit}}),listItemActivelink:_defineProperty({display:'block',marginBottom:theme.spacing.unit*3},theme.breakpoints.up('md'),{display:'block',marginTop:'auto'}),listItemLink:{color:'#333','&:hover':{fontWeight:500}},listItemWrapper:(_listItemWrapper={marginBottom:theme.spacing.unit*2,width:'100%',paddingRight:32},_defineProperty(_listItemWrapper,theme.breakpoints.up('md'),{paddingRight:0}),_defineProperty(_listItemWrapper,theme.breakpoints.down('md'),{marginBottom:theme.spacing.unit*4}),_listItemWrapper)};});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/flow");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/OneDaciaHeaderDesktopMenuMegaDropdownLinks");

/***/ })

/******/ });
});
//# sourceMappingURL=OneDaciaHeaderDesktopMenuMegaDropdownColumns.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/OneDaciaHeaderDesktopMenuMegaDropdownColumns.js
// module id = 590
// module chunks = 0